const searchButton = document.getElementById("search-button");

if (searchButton) {
    searchButton.addEventListener("mousedown", () => {
        searchButton.style.borderColor = "#edd761";
    });
}
